import { FC } from "react";
import { FaInstagram } from "react-icons/fa";
import styled from "styled-components";

const NoWrap = styled.div`
  align-items: center;
  display: flex;
  white-space: nowrap;
`;

const InstagramIcon = styled(FaInstagram)`
  width: 20px;
  height: 20px;
  color: white;
`;

type InstagramProps = {};

export const Instagram: FC<InstagramProps> = () => {
  return (
    <NoWrap>
      <a
        href="https://www.instagram.com/enefel_the_game/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <InstagramIcon />
      </a>
    </NoWrap>
  );
};
